// External libraries
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

// Internal modules
import {
  ADDRESS_MARGIN_BOTTOM_PP,
  bodyLgMediumStyles,
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  FONT_SIZE_MEDIUM,
  FONT_WEIGHT_NORMAL_PP,
  HEADER_COLOR,
  HIGH_CONTRAST_TEXT_COLOR,
} from '@/styles';

const addressHeaderStyles = css`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_MEDIUM};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 1.33;
  margin-bottom: ${ADDRESS_MARGIN_BOTTOM_PP};
  padding-top: 6px;

  @media (min-width: 365px) {
    font-size: ${FONT_SIZE_MEDIUM};
  }

  .overrides-font-4-2 & {
    ${bodyLgMediumStyles}
  }
`;

const countryContainerStyleOverrides = css`
  background-color: ${DISABLED_BACKGROUND_COLOR};
  border-color: ${DISABLED_BORDER_COLOR};

  > select {
    color: ${HEADER_COLOR};
  }
`;

const getFieldsetStyles = ({
  hasShipToBillingCheckbox,
  isBilling,
}: {
  hasShipToBillingCheckbox: boolean;
  isBilling: boolean;
}): SerializedStyles => css`
  margin: 16px 0;

  @media (min-width: 365px) {
    margin-bottom: ${hasShipToBillingCheckbox && isBilling ? 18 : 24}px;
  }

  /**
   * We are setting the 'margin-bottom' on the container, so the last child of
   * the container doesn't need to have a 'margin-bottom' property.
   */
  > div:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export {
  addressHeaderStyles,
  countryContainerStyleOverrides,
  getFieldsetStyles,
};
